<template>
  <div class="appLayout">
    <AppHeader />
    <div class="app-main-container" v-if="Object.keys(buckets).length">
      <AppNav />
      <AppMain />
    </div>
    <transition name="fade-transform" mode="out-in">
      <div
        class="app-modal"
        v-if="appModal"
        @click="$store.commit('windowHandle')"
      ></div>
    </transition>
  </div>
</template>

<script>
import AppHeader from "./components/appHeader";
import AppNav from "./components/appNav";
import AppMain from "./components/appMain";

import { mapGetters } from "vuex";

export default {
  components: {
    AppHeader,
    AppNav,
    AppMain
  },
  computed: {
    ...mapGetters(["appModal", "buckets"])
  },
  methods: {},

  async mounted() {
    let res = await this.$http.getOssBuckets();
    this.$store.commit("setBuckets", res.data);
  }
};
</script>

<style lang="scss" scoped>
.appLayout {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .app-main-container {
    flex: 1;
    display: flex;
    overflow: hidden;
  }
  .app-modal {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 100;
  }
}
</style>
